import { render, staticRenderFns } from "./examinationAssignmentAssignedDialogEmail.vue?vue&type=template&id=690bdb35"
import script from "./examinationAssignmentAssignedDialogEmail.vue?vue&type=script&lang=js"
export * from "./examinationAssignmentAssignedDialogEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports